// TODO we shouldn't be hardcoding the client id here, instead read from env or config
const stravaAuthUrl = "https://www.strava.com/oauth/authorize?client_id=98671&redirect_uri=https://app.thegradientgames.com/strava/success&response_type=code&scope=activity:read,activity:write";
export default stravaAuthUrl